var Payment = {

	init: function() {
		Payment.acceptTerms();
	},

	acceptTerms: function() {
		$('.accept-terms').click(function() {
			if($('#terms-conditions').is(':checked') == false) {
				$('#termsmModal').modal('hide');
				$('#terms-conditions').prop('checked', true);
				$('.gst').removeClass('inactive');
				$('#gst-number').prop('disabled', false);
				$('#pay-btn').removeClass('inactive').prop('disabled', false);
				$('.accept-terms span').css('display' ,'inline');
			}
			else {
				$('#termsmModal').modal('hide');
				$('#terms-conditions').prop('checked', false);
				$('.gst').addClass('inactive');
				$('#gst-number').prop('disabled', true);
				$('#pay-btn').addClass('inactive').prop('disabled', true);
				$('.accept-terms span').css('display' ,'none');
			}
		});
	} 
}